import { TextField } from '@mui/material';

function MUIInput({ ...params }) {
  return <TextField id='outlined-search' {...params} />;
}

export default MUIInput;
